import User from '~/client/src/shared/models/User'
import { wasPhoneCleared } from '~/client/src/shared/utils/phoneNumberHelpers'

// STX1-637: which submitted members had a loaded phone number that the user
// emptied. Only a genuine edit that cleared an existing number qualifies:
//  - add-mode rows (newProjectMember = new User(null, null)) have no id → excluded
//  - add-existing-user (loaded '' → submitted '') is not a clear → excluded
// The loaded value comes from the pristine store entry, not the edited copy.
export function getPhoneClearTargets(
  items: User[],
  loadedPhoneById: (id: string) => string | undefined | null,
): string[] {
  return items
    .filter(item => {
      const id = item?.id
      if (!id) {
        return false
      }
      return wasPhoneCleared(loadedPhoneById(id) || '', item.phoneNumber || '')
    })
    .map(item => item.id)
}
